import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { IPropertyBag } from '@deity-io/di-data-basics';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigateToEntityProps {
  linkText?: string;
}
export const NavigateBack: FC<NavigateToEntityProps> = () => {
  const { pathname, state } = useLocation<IPropertyBag>();
  const entityListPath = pathname.split('/');
  entityListPath.pop();

  const url = state?.previous ? state.previous.path : entityListPath.join('/');
  const name = state?.previous ? state.previous.label : entityListPath[entityListPath.length - 1];

  return (
    <FlexLayout alignItems="center" width="full" height="full">
      <Link to={url} style={{ textDecoration: 'none' }}>
        <FlexLayout alignItems="center">
          <Icon src="arrowBack" color="primaryText" stroke="transparent" />
          <H4 fontWeight="bold" color="primaryText" ml="xs" style={{ textTransform: 'capitalize' }}>
            {name}
          </H4>
        </FlexLayout>
      </Link>
    </FlexLayout>
  );
};
